export default "__VITE_ASSET__B8TlgW9L__"